
import React from 'react';
import { AlertCircle, Crown, Zap } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { useSubscription } from '@/contexts/SubscriptionContext';

interface LimitationNoticeProps {
  type: 'fileCount' | 'fileSize' | 'format' | 'quality' | 'resolution';
  current?: number;
  max?: number;
  className?: string;
}

const LimitationNotice = ({ type, current, max, className = "" }: LimitationNoticeProps) => {
  const { isPremium, createCheckout } = useSubscription();

  if (isPremium) return null;

  const notices = {
    fileCount: {
      title: `Límite de archivos (${current}/${max})`,
      description: 'Plan Premium: Imágenes ilimitadas',
      action: 'Desbloquear ilimitadas'
    },
    fileSize: {
      title: 'Tamaño máximo: 10MB',
      description: 'Plan Premium: Hasta 50MB por imagen',
      action: 'Aumentar límite'
    },
    format: {
      title: 'Solo archivos JPEG',
      description: 'Plan Premium: JPEG, PNG, WebP y más formatos',
      action: 'Desbloquear formatos'
    },
    quality: {
      title: 'Calidad máxima: 90%',
      description: 'Plan Premium: Hasta 95% de calidad ultra',
      action: 'Desbloquear calidad ultra'
    },
    resolution: {
      title: 'Resolución máxima: 1920x1080px',
      description: 'Plan Premium: Hasta 4K (4096x2160px)',
      action: 'Desbloquear 4K'
    }
  };

  const notice = notices[type];

  return (
    <Alert className={`border-orange-200 bg-orange-50 ${className}`}>
      <AlertCircle className="w-4 h-4 text-orange-600" />
      <AlertDescription className="flex items-center justify-between">
        <div>
          <div className="font-medium text-orange-800">{notice.title}</div>
          <div className="text-sm text-orange-700 mt-1">{notice.description}</div>
        </div>
        <Button
          size="sm"
          onClick={() => createCheckout('monthly')}
          className="bg-purple-600 hover:bg-purple-700 text-white ml-4"
        >
          <Crown className="w-3 h-3 mr-1" />
          {notice.action}
        </Button>
      </AlertDescription>
    </Alert>
  );
};

export default LimitationNotice;
